import { useCheckFanStatusQuery } from '../redux/api/creators-api';
import { useAuthSession } from './use-auth-session';

export const useCheckFanStatus = (creatorId: string) => {
  const { isAuthenticated } = useAuthSession();
  const { data, isLoading, error } = useCheckFanStatusQuery(creatorId, {
    skip: !creatorId || !isAuthenticated,
  });

  return {
    isFan: data?.isFan ?? false,
    isLoading,
    error,
  };
};
